// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import _ from 'lodash';

// import { CAN_USE_DOM } from 'common/constants';
import { Responsive } from 'client/components/common';
import { detectIE } from 'common/utils/detect-ie';
// import { tracker } from 'common/utils/ga';
import { fileLink } from 'common/utils/file-link';
import { parseSearch } from 'common/utils/parse-react-router-search';

import Main from 'client/components/pages/Main';
import Banner from 'client/components/common/Banner';
import { ROOT_ROUTE } from 'client/constants';
import * as css from './App.scss';

type Props = {|
	history: RouterHistory,
	location: RouterLocation,
	isBusy?: boolean,
	checklistInfo: Checklist,
	galleryItems: any,
|};

class App extends React.PureComponent<Props> {
	static defaultProps = {
		isBusy: true,
	};

	async componentDidMount() {
		const isIE = detectIE();
		// tracker.init('UA-113524208-35');

		if (!this.props.isBusy) {
			this.removeRootPreloader();
		}

		if (document && document.body) {
			document.body.setAttribute('data-browser', isIE ? 'ie' : 'not-ie');
		}
	}

	async componentDidUpdate(prevProps: Props) {
		if (!this.props.isBusy && prevProps.isBusy) {
			this.removeRootPreloader();
		}
	}

	renderHelmet = () => {
		const { checklistInfo, location, galleryItems } = this.props;
		const shareType = _.get(parseSearch(location.search), 'shareType', '');
		const total = _.get(parseSearch(location.search), 'total', '');
		const selected = _.get(parseSearch(location.search), 'selected', '');
		const itemId = _.get(parseSearch(location.search), 'itemId', '');
		const shareItemId = _.get(parseSearch(location.search), 'shareItemId', '');
		const item = galleryItems.find(i => i.id === itemId);
		const faviconImg = fileLink(_.get(checklistInfo, 'graphics.favicon', ''));
		const description = _.get(checklistInfo, 'general.seoDescription');

		const shareItem = galleryItems.find(i => i.id === shareItemId);

		const title = _.get(checklistInfo, 'general.seoTitle', '');

		const ogTitleFunc = () => {
			if (shareItemId && shareItem) {
				const shareTitleForItems = _.get(checklistInfo, 'general.shareTitleForItem', '').replace(
					'{#####}',
					shareItem.title
				);
				return shareTitleForItems;
			}
			return _.get(checklistInfo, 'general.shareTitle', '') || title;
		};

		const ogDescriptionFunc = () => {
			if (shareItemId && shareItem) {
				const shareDescriptionForItems = _.get(checklistInfo, 'general.shareDescriptionForItem', '').replace(
					'{#####}',
					shareItem.title
				);
				return shareDescriptionForItems;
			}

			const generalOgDescription = _.get(checklistInfo, 'general.shareDescription', '') || description;
			let resultDescription;

			if (item) {
				resultDescription = _.get(checklistInfo, 'form.shareResultsText', '')
					.replace('{user_number}', selected)
					.replace('{max_items_number}', total)
					.replace('{item_name}', item.title);
			} else {
				resultDescription = _.get(checklistInfo, 'form.shareResultsText', '')
					.replace('{user_number}', selected)
					.replace('{max_items_number}', total);
			}
			return shareType === 'custom' ? resultDescription : generalOgDescription;
		};

		const ogTitle = ogTitleFunc();
		const ogDescription = ogDescriptionFunc();
		const ogImage = shareItem
			? fileLink(_.get(shareItem, 'image', ''))
			: fileLink(_.get(checklistInfo, 'general.shareImage', ''));
		return (
			<Helmet
				title={title}
				link={[{ rel: 'icon', type: 'image/png', href: `${faviconImg}` }]}
				meta={[
					{
						title: 'title',
						content: `${title}`,
					},
					{
						name: 'description',
						content: `${description}`,
					},
					{ property: 'og:title', content: `${ogTitle}` },
					{ property: 'og:description', content: `${ogDescription}` },
					{ property: 'og:image', content: `${ogImage}` },
				]}
			/>
		);
	};

	removeRootPreloader = () => {
		const preloadingScreen: ?HTMLElement = document.querySelector('.preloading-screen');

		if (preloadingScreen) {
			preloadingScreen.addEventListener('transitionend', (e: TransitionEvent) => {
				setTimeout(() => {
					if (document && document.body && e.target === preloadingScreen) {
						document.body.removeChild(preloadingScreen);
					}
				}, 1000);
			});
			preloadingScreen.style.opacity = '0';
			preloadingScreen.style.zIndex = '-1000';
		}
	};

	renderRoute = (Component: Function) => {
		return ({ match, ...props }) => {
			return <Component {...props} in={match !== null} />;
		};
	};

	render() {
		const { checklistInfo } = this.props;
		const isShowBanner = _.get(checklistInfo, 'general.isShowBanner', true);
		const isMobile = Responsive.isMatching(Responsive.MOBILE);

		return (
			<div id="app" className={css.app}>
				{this.renderHelmet()}
				<div className={css.content}>
					<Route exact path={ROOT_ROUTE}>
						{({ match, ...props }) => <Main location={props.location} in={!!match} />}
					</Route>
				</div>
				{isShowBanner && isMobile && (
					<Banner adsCustomParam={_.get(checklistInfo, 'general.cooladataID', '')} />
				)}
			</div>
		);
	}
}

const mapState = (state: ClientStore) => ({
	isBusy: state.checklist.isBusy,
	checklistInfo: state.checklist.item,
	galleryItems: state.galleryItems.items,
});

const mapDispatch = {};

export default withRouter(connect(mapState, mapDispatch)(App));
